import axios from "axios";
import { toast } from "react-toastify";
export const GetAllSection = (data) => {
  return {
    type: "get_allsections",
    payload: data,
    loader: false,
  };
};
export function getallSection() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Projects/Sections/GetAll`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllSection(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
